export type PrismicDocuemntLink = {
  type: string | null;
  uid?: string | null;
  tags?: string[];
};

export const linkResolver = (doc: PrismicDocuemntLink) => {
  /**
   * For preview renderings and error cases
   * Return homepage instead of empty string to prevent redirect issues
   */
  if (!doc?.type) {
    console.warn("[linkResolver] Document type not found!");
    return "/";
  }

  let path = doc.uid?.replace(/_/g, "/");

  if (path && !path.endsWith("/")) path = `${path}/`;

  const isAccounting = doc.tags?.includes("account-segment");

  switch (doc.type) {
    case "page":
    case "page_script":
      /**
       * IMPORTANT: Accounting Segment Path Prefix
       * This forces all documents tagged with `account-segment` into the `/experts-comptables/` path.
       * Even though the Segment Toggle reads its prefix from Prismic Global Settings, `linkResolver.ts`
       * is a synchronous utility used throughout the app and cannot dynamically query Prismic.
       * Therefore, if you ever change the accounting prefix in Global Settings, you MUST manually
       * update the hardcoded `/experts-comptables/` strings below to match, otherwise page generation
       * (in gatsby-node) and internal links will break.
       */
      if (path === "accueil/" || path === "home/") {
        return isAccounting ? "/experts-comptables/" : "/";
      }

      if (isAccounting) {
        // Prevent double prefixing if the CMS document UID was manually prefixed
        if (path?.startsWith("experts-comptables/")) {
          return `/${path}`;
        }
        return `/experts-comptables/${path}`;
      }

      return `/${path}`;

    case "page_landing":
      if (isAccounting) {
        // Remove any redundant prefix if the UID was manually prefixed in the CMS
        const cleanPath = path?.startsWith("experts-comptables/")
          ? path.replace("experts-comptables/", "")
          : path;
        return `/experts-comptables/lp/${cleanPath}`;
      }
      return `/lp/${path}`;

    default:
      console.warn(`[linkResolver] Unknown document type: ${doc.type}!`);
      return "/";
  }
};
